export default class BaseValueObject {
  constructor(obj) {
    const assignee = obj || this.constructor.properties;
    Object.assign(this, assignee);
  }
}
